/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../connect/v2/common/money';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "resources": {
            "nested": {
              "rewards": {
                "nested": {
                  "RewardActivity": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "type": {
                        "type": ".squareup.corporate_card.resources.rewards.RewardActivity.Type",
                        "id": 2,
                        "rule": "optional"
                      },
                      "rewardPointsMoney": {
                        "type": ".squareup.connect.v2.common.Money",
                        "id": 3,
                        "rule": "optional"
                      },
                      "transactionAmountMoney": {
                        "type": ".squareup.connect.v2.common.Money",
                        "id": 4,
                        "rule": "optional"
                      },
                      "createdAt": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "rewardMultiplier": {
                        "type": "int32",
                        "id": 6,
                        "rule": "optional"
                      },
                      "description": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "rewardExpiresAt": {
                        "type": "string",
                        "id": 8,
                        "rule": "optional"
                      },
                      "earningDetails": {
                        "type": ".squareup.corporate_card.resources.rewards.RewardEarningDetails",
                        "id": 9
                      },
                      "freeProcessingDetails": {
                        "type": ".squareup.corporate_card.resources.rewards.FreeProcessingRedemptionDetails",
                        "id": 10
                      },
                      "statementCreditDetails": {
                        "type": ".squareup.corporate_card.resources.rewards.StatementCreditDetails",
                        "id": 11
                      },
                      "adjustmentDetails": {
                        "type": ".squareup.corporate_card.resources.rewards.AdjustmentDetails",
                        "id": 12
                      },
                      "squareSavingsCashbackDetails": {
                        "type": ".squareup.corporate_card.resources.rewards.SquareSavingsCashbackRedemptionDetails",
                        "id": 13
                      }
                    },
                    "nested": {
                      "Type": {
                        "values": {
                          "TYPE_DO_NOT_USE": 0,
                          "REWARD_REDEMPTION": 1,
                          "REWARD_EARNED": 2,
                          "HACKWEEK_REWARD_CASHAPP_REDEMPTION": 3,
                          "REWARD_STATEMENT_CREDIT_REDEMPTION": 4,
                          "REWARD_ADJUSTMENT": 5,
                          "REWARD_SQUARE_SAVINGS_CASHBACK_REDEMPTION": 6
                        }
                      },
                      "reward_details": {
                        "oneof": ["earningDetails", "freeProcessingDetails", "statementCreditDetails", "adjustmentDetails", "squareSavingsCashbackDetails"]
                      }
                    }
                  },
                  "RewardEarningDetails": {
                    "fields": {
                      "cashbackValue": {
                        "type": ".squareup.connect.v2.common.Money",
                        "id": 1,
                        "rule": "optional"
                      },
                      "transactionAmountMoney": {
                        "type": ".squareup.connect.v2.common.Money",
                        "id": 2,
                        "rule": "optional"
                      },
                      "description": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "FreeProcessingRedemptionDetails": {
                    "fields": {
                      "freeProcessingAmount": {
                        "type": ".squareup.connect.v2.common.Money",
                        "id": 1,
                        "rule": "optional"
                      },
                      "cashbackEquivalent": {
                        "type": ".squareup.connect.v2.common.Money",
                        "id": 2,
                        "rule": "optional"
                      },
                      "expiresAt": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "StatementCreditDetails": {
                    "fields": {
                      "creditAmount": {
                        "type": ".squareup.connect.v2.common.Money",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "SquareSavingsCashbackRedemptionDetails": {
                    "fields": {
                      "amount": {
                        "type": ".squareup.connect.v2.common.Money",
                        "id": 1,
                        "rule": "optional"
                      },
                      "redemptionAccountToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "redemptionAccountName": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "AdjustmentDetails": {
                    "fields": {
                      "adjustmentAmount": {
                        "type": ".squareup.connect.v2.common.Money",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.rewards?.nested?.RewardActivity && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.rewards?.nested?.RewardActivity?.nested?.Type && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.rewards?.nested?.RewardEarningDetails && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.rewards?.nested?.FreeProcessingRedemptionDetails && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.rewards?.nested?.StatementCreditDetails && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.rewards?.nested?.SquareSavingsCashbackRedemptionDetails && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.rewards?.nested?.AdjustmentDetails) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Information around redeemed free processing
 * --
 *
 * SOURCE RewardActivity @ squareup/corporate_card/resources/rewards/reward_activity.proto at 10:1
 */
export const RewardActivity = $root.lookupType('squareup.corporate_card.resources.rewards.RewardActivity');
fixType(RewardActivity);
Builder.createAndAttachToType(RewardActivity);
/**
 * SOURCE Type @ squareup/corporate_card/resources/rewards/reward_activity.proto at 11:3
 */
RewardActivity.Type = $root.lookupEnum('squareup.corporate_card.resources.rewards.RewardActivity.Type').values;
/**
 * SOURCE RewardEarningDetails @ squareup/corporate_card/resources/rewards/reward_activity.proto at 75:1
 */
export const RewardEarningDetails = $root.lookupType('squareup.corporate_card.resources.rewards.RewardEarningDetails');
fixType(RewardEarningDetails);
Builder.createAndAttachToType(RewardEarningDetails);
/**
 * SOURCE FreeProcessingRedemptionDetails @ squareup/corporate_card/resources/rewards/reward_activity.proto at 92:1
 */
export const FreeProcessingRedemptionDetails = $root.lookupType('squareup.corporate_card.resources.rewards.FreeProcessingRedemptionDetails');
fixType(FreeProcessingRedemptionDetails);
Builder.createAndAttachToType(FreeProcessingRedemptionDetails);
/**
 * SOURCE StatementCreditDetails @ squareup/corporate_card/resources/rewards/reward_activity.proto at 109:1
 */
export const StatementCreditDetails = $root.lookupType('squareup.corporate_card.resources.rewards.StatementCreditDetails');
fixType(StatementCreditDetails);
Builder.createAndAttachToType(StatementCreditDetails);
/**
 * SOURCE SquareSavingsCashbackRedemptionDetails @ squareup/corporate_card/resources/rewards/reward_activity.proto at 116:1
 */
export const SquareSavingsCashbackRedemptionDetails = $root.lookupType('squareup.corporate_card.resources.rewards.SquareSavingsCashbackRedemptionDetails');
fixType(SquareSavingsCashbackRedemptionDetails);
Builder.createAndAttachToType(SquareSavingsCashbackRedemptionDetails);
/**
 * SOURCE AdjustmentDetails @ squareup/corporate_card/resources/rewards/reward_activity.proto at 133:1
 */
export const AdjustmentDetails = $root.lookupType('squareup.corporate_card.resources.rewards.AdjustmentDetails');
fixType(AdjustmentDetails);
Builder.createAndAttachToType(AdjustmentDetails);